module.exports = __webpack_public_path__ + "img/20210206_180202.09e0f38d.jpg";